import { useSelector, useDispatch } from 'react-redux';

import { RadioButtonGroup } from '../../components/RadioButtonGroup';
import { RootState } from '../../redux/store';
import { changeAppTheme } from '../../redux/appConfigSlice';
import { options } from './options';
import classes from './ContrastSelection.module.css';
import { useState } from 'react';
import errorCodeDescription from '../../components/ErrorCard/errorProperties';
import { ErrorCard } from '../../components/ErrorCard';


const ContrastSelection = () => {
    const [errorCode, setErrorCode] = useState<string>('');
    const contrastMode = useSelector((state: RootState) => state.appConfigSlice.appTheme);
    const dispatch = useDispatch();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            dispatch(changeAppTheme(e.target.value));
            document.documentElement.setAttribute('data-theme', e.target.value);
        } catch (err) {
            setErrorCode("V202");
            console.error(errorCodeDescription[errorCode]);
        }
    };

    if (errorCode) {
        return <ErrorCard errorCode={errorCode} />;
    }

    return (
        <>
            <RadioButtonGroup
                id="contrastmode"
                name="contrastMode"
                onChange={handleChange}
                options={options}
                value={contrastMode}
                className={classes.container}
            />
        </>

    );
};
export default ContrastSelection;
